import { Bone } from "../Bones/bone";
import { AddAnimationExtensions } from "./animatable.core";
import { Scene } from "core/scene";
export * from "./animatable.core";
// Connect everything!
AddAnimationExtensions(Scene, Bone);
//# sourceMappingURL=animatable.js.map